
export const ADTECH_SERVER_DEV='http://localhost:3004'

export const ADTECH_SERVER_PROD='https://api.retargetpal.com/api/v1'

export const ADTECH_FRONT_DEV='http://localhost:5000'

export const ADTECH_FRONT_PROD='https://www.retargetpal.com'

